import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import { mergeRefs } from '@react-aria/utils';
import '../../../../../SelectionListBox/index.js';
import '../../../../../ThemableContainer/index.js';
import { useSelectListBox } from './hooks/useSelectListBox.js';
import { VirtualizedSelectionListBox } from '../../../../../SelectionListBox/VirtualizedSelectionListBox.js';
import { SelectionListBox } from '../../../../../SelectionListBox/SelectionListBox.js';
import { ThemableContainer } from '../../../../../ThemableContainer/ThemableContainer.js';

var SelectListBox = /*#__PURE__*/React.memo(/*#__PURE__*/React.forwardRef(function (props, ref) {
  var isVirtualized = props.isVirtualized;
  var _useSelectListBox = useSelectListBox(props),
    selectionListBoxProps = _useSelectListBox.selectionListBoxProps,
    selectionListBoxRef = _useSelectListBox.selectionListBoxRef;
  var ListBox = isVirtualized ? VirtualizedSelectionListBox : SelectionListBox;
  return /*#__PURE__*/React.createElement(ThemableContainer, {
    intent: "generic"
  }, /*#__PURE__*/React.createElement(ListBox, _extends({
    ref: mergeRefs(ref, selectionListBoxRef)
  }, selectionListBoxProps)));
}));

export { SelectListBox };
//# sourceMappingURL=SelectListBox.js.map
